/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Person/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Name from './Name/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Person({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Email/Emails/Content/Email/Related/Content/Popup/Content/Persons/Person"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Person.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z2fMjSV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
</div>
{children}
</React.Fragment>)
}